import { render, staticRenderFns } from "./Supplementary.vue?vue&type=template&id=8452e350&scoped=true&"
import script from "./Supplementary.vue?vue&type=script&lang=ts&"
export * from "./Supplementary.vue?vue&type=script&lang=ts&"
import style0 from "./Supplementary.vue?vue&type=style&index=0&id=8452e350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8452e350",
  null
  
)

export default component.exports